<template>
<div class="chapter">
<div class="inner_page">
<p class="normala"><span class="smallcaps">WHO’S WHO IN FILMS</span></p>
<p class="blq-normala">CIRAK (Ši’răk) JASON PETER</p>
<p class="blq-normala">B. Rakovnik, Czechoslovakia, Feb. 11, 1919. Only son of Vanos &amp; Anna Cirak. Fled to U.S. to escape Nazi persecution. Rose to sudden fame through award-winning documentary, <i>The Refugees</i>, filmed with borrowed equipment and financed by working at odd jobs. Subsequent films included <i>Soldier Boy</i> (1948), <i>Backhand</i> (1952), <i>Even So</i> (1958), <i>Crooked Mile</i> (1965). None achieved success of earliest work. M. Marion Estes Plummer, member of a prominent eastern family, June 1, 1959. One dau. Jennifer Maria, b. Oct. 29, 1961. Present residence unknown.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm01.vue?71ee3192